import React, { useEffect, useState } from 'react';
import Modal from '../../../comun/Modal';
import { puntosApi, asList, cardStyle, pillStyle } from './puntosApi';
import { Estrella, Vaso } from '../../publico/Iconos';

// stock vacío = sin límite (el control lo llevan los insumos del producto)
const EMPTY = { name: '', description: '', product: '', points_cost: 10, stock: '', is_active: true, display_order: 0, image: null };

const RegalosPuntos = () => {
    const [rewards, setRewards] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState(EMPTY);
    const [editing, setEditing] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [products, setProducts] = useState([]);

    const load = async () => {
        try {
            const res = await puntosApi.rewards();
            setRewards(asList(res.data));
        } catch (err) {
            console.error('[Puntos] Error cargando regalos', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
        puntosApi.products()
            .then((res) => setProducts(asList(res.data)))
            .catch((err) => console.error('[Puntos] Error cargando productos', err));
    }, []);

    const openNew = () => { setEditing(null); setForm(EMPTY); setIsOpen(true); };
    const openEdit = (r) => {
        setEditing(r);
        setForm({ ...EMPTY, ...r, product: r.product || '', stock: r.stock ?? '', image: null });
        setIsOpen(true);
    };

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value }));
    };

    // Al elegir el producto se sugiere el nombre "<Producto> GRATIS" si el nombre está vacío o era sugerido
    const handleProductChange = (e) => {
        const id = e.target.value;
        const product = products.find((p) => String(p.id) === id);
        setForm((prev) => {
            const previous = products.find((p) => String(p.id) === String(prev.product));
            const autoName = !prev.name || (previous && prev.name === `${previous.name} GRATIS`);
            return { ...prev, product: id, name: autoName && product ? `${product.name} GRATIS` : prev.name };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData();
        ['name', 'description', 'product', 'points_cost', 'stock', 'display_order'].forEach((k) => fd.append(k, form[k] ?? ''));
        fd.append('is_active', form.is_active ? 'true' : 'false');
        if (form.image instanceof File) fd.append('image', form.image);

        setSaving(true);
        try {
            await puntosApi.saveReward(editing?.id, fd);
            setIsOpen(false);
            load();
        } catch (err) {
            console.error('[Puntos] Error guardando regalo', err);
            alert(`Error al guardar: ${JSON.stringify(err.response?.data || err.message)}`);
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (r) => {
        if (!window.confirm(`¿Eliminar "${r.name}"? Los canjes ya registrados se conservan.`)) return;
        try {
            await puntosApi.deleteReward(r.id);
            load();
        } catch (err) {
            console.error('[Puntos] Error eliminando regalo', err);
            alert('No se pudo eliminar el regalo.');
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <p style={{ margin: 0, color: '#6b7280' }}>Lo que los clientes pueden reclamar en caja con sus puntos.</p>
                <button className="btn btn-primary" onClick={openNew}>+ Nuevo regalo</button>
            </div>

            {loading ? <p>Cargando…</p> : rewards.length === 0 ? (
                <div style={{ ...cardStyle, textAlign: 'center', color: '#6b7280' }}>
                    Aún no hay regalos. Crea el primero, por ejemplo "Postre gratis — 10 puntos".
                </div>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '1rem' }}>
                    {rewards.map((r) => (
                        <div key={r.id} style={{ ...cardStyle, opacity: r.is_active ? 1 : 0.6 }}>
                            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                                <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--sidebar-bg)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8rem', flexShrink: 0 }}>
                                    {r.display_image ? <img src={r.display_image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <Vaso size={28} style={{ color: 'var(--primary-color)' }} />}
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontWeight: 700, color: 'var(--primary-color)' }}>{r.name}</div>
                                    {r.product_name && <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>Producto: {r.product_name}</div>}
                                    <span style={pillStyle}><Estrella size={13} style={{ verticalAlign: '-2px', color: '#d9a441' }} /> {r.points_cost} pts</span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '0.5rem', margin: '1rem 0' }}>
                                <div style={{ flex: 1, background: r.stock === null || r.stock > 0 ? '#e6f6ee' : '#fdecec', borderRadius: '10px', padding: '0.5rem', textAlign: 'center' }}>
                                    <div style={{ fontSize: r.stock === null ? '1rem' : '1.4rem', fontWeight: 800, lineHeight: r.stock === null ? '2.1rem' : undefined }}>{r.stock === null ? 'Sin límite' : r.stock}</div>
                                    <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>disponibles</div>
                                </div>
                                <div style={{ flex: 1, background: 'var(--sidebar-bg)', borderRadius: '10px', padding: '0.5rem', textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.4rem', fontWeight: 800 }}>{r.claimed_count}</div>
                                    <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>reclamados</div>
                                </div>
                            </div>
                            {!r.is_active && <div style={{ fontSize: '0.8rem', color: '#9b1c1c', marginBottom: '0.5rem' }}>Inactivo (no se muestra)</div>}
                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => openEdit(r)}>Editar</button>
                                <button className="btn btn-danger" onClick={() => handleDelete(r)}>Eliminar</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} title={editing ? 'Editar regalo' : 'Nuevo regalo'}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Producto que se regala</label>
                        <select name="product" value={form.product} onChange={handleProductChange} className="form-control">
                            <option value="">Sin producto (no descuenta inventario)</option>
                            {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                        </select>
                        <small style={{ color: '#6b7280' }}>Al canjear se descuentan los insumos de su receta (por ejemplo, el vaso).</small>
                    </div>
                    <div className="form-group">
                        <label>Nombre</label>
                        <input name="name" value={form.name} onChange={handleChange} className="form-control" required placeholder="Fremonada GRATIS" />
                    </div>
                    <div className="form-group">
                        <label>Descripción (se muestra en la página pública)</label>
                        <input name="description" value={form.description} onChange={handleChange} className="form-control" placeholder="Vaso de fremonada, sabor a elección" />
                    </div>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Puntos necesarios</label>
                            <input type="number" min="1" name="points_cost" value={form.points_cost} onChange={handleChange} className="form-control" required />
                        </div>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Unidades (vacío = sin límite)</label>
                            <input type="number" min="0" name="stock" value={form.stock} onChange={handleChange} className="form-control" placeholder="Sin límite" />
                        </div>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Orden</label>
                            <input type="number" min="0" name="display_order" value={form.display_order} onChange={handleChange} className="form-control" />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Imagen (opcional: si no subes una, se usa la del producto)</label>
                        <input type="file" accept="image/*" name="image" onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>
                            <input type="checkbox" name="is_active" checked={form.is_active} onChange={handleChange} style={{ marginRight: '8px' }} />
                            Activo
                        </label>
                    </div>
                    <div className="form-actions">
                        <button type="button" className="btn btn-secondary" onClick={() => setIsOpen(false)}>Cancelar</button>
                        <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default RegalosPuntos;
